<template>
    <ul class="sidebarMain">
      <li>
          <div class="profile">{{initial}}</div>
          <p class="fullname">{{fullName}}</p>
      </li>
      
      <div class="sep"></div>

      <li v-for="menu in menus" :key="menu.text">
          <b-button class="bt bt-icon"  :to="menu.link">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
              <p> {{menu.text}}</p>
          </b-button>
      </li>

      <div class="sep"></div>

      <li v-for="menu in menuFavorites" :key="menu.text">
          <b-button class="bt bt-icon options"  :to="menu.link">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
              <p> {{menu.text}}</p>
          </b-button>
      </li>

      <div class="sep"></div>

       <li v-for="menu in menuGifts" :key="menu.text">
          <b-button class="bt bt-icon options"  :to="menu.link">
              <span>
                <font-awesome-icon :icon="[menu.iconType, menu.iconName]" />
              </span>
              <p> {{menu.text}}</p>
          </b-button>
      </li>
    </ul>
</template>

<script>
import { mapGetters } from 'vuex'


export default {
  name: "SidebarMain",

  components: {
  },
  
  data() {
    return {
        menus: [],
        menuFavorites: [],
        menuGifts: [],
        initial:'PC',
        fullName:'Pierre Cervo'
    }
  },
  computed: {
    ...mapGetters([
      'getMenu',
      'getMenuFavorites',
      'getMenuGifts',
      'getInitial',
      'getFullName'
    ])
  },
  created (){
    const pageName = window.location.pathname.split("/").pop();
    let theSubmenu = this.getMenu;
    this.menus = theSubmenu.filter(word => word.text.toLowerCase() != pageName);
    //
   this.menuFavorites = this.getMenuFavorites;
   this.menuGifts = this.getMenuGifts;
   this.initial = this.getInitial;
   this.fullName = this.getFullName;
   //
  },
  methods: {
  }
}
</script>